import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAnalytics } from '@bonusly/analytics';
import { Box, Button, Flex, PencilSolid, Text } from '@bonusly/design-system';

import { LabelsDisplay } from '../../components/labels/labels-display';
import { useBookmark } from '../../context';
import { BookmarkEvent } from '../../types/event';

export const BookmarkNotes: FC = () => {
	const { t } = useTranslation('bookmarks');
	const { onOpenModal, bookmark } = useBookmark();
	const { track } = useAnalytics();

	if (bookmark === undefined) return null;

	const hasContent = bookmark.notes || bookmark.labels.length > 0;

	return (
		<Box w="full" p={3} bg="grayAlpha.100" borderRadius="12px" my={4}>
			<Flex justifyContent="space-between" alignItems="center">
				<Flex direction="column" w="full" pl={1}>
					<Flex justifyContent="space-between" alignItems="center">
						<Flex alignItems="center" gap={1}>
							<Text fontSize="md" variant="strong">
								{t('bookmark_notes.title')}
							</Text>
						</Flex>
						{hasContent && (
							<Button
								aria-label={t('bookmark_notes.edit_bookmark_notes') || ''}
								colorScheme="secondary"
								variant="alpha"
								size="xs"
								leftIcon={<PencilSolid size="xs" />}
								onClick={onOpenModal}
							>
								{t('edit')}
							</Button>
						)}
					</Flex>

					<Flex direction="column" pt={1}>
						{bookmark.notes ? (
							<Text mb={1}>{bookmark.notes}</Text>
						) : (
							bookmark.labels.length === 0 && (
								<Text fontSize="sm" mb={1} color="text.softest">
									{t('bookmark_notes.disclaimer')}
								</Text>
							)
						)}
						<LabelsDisplay labelsToShow={bookmark.labels} />
					</Flex>
				</Flex>

				{!hasContent && (
					<Button
						aria-label={t('bookmark_notes.add_bookmark_notes') || ''}
						colorScheme="secondary"
						variant="alpha"
						mr={1}
						onClick={() => {
							onOpenModal();
							track(BookmarkEvent.AddBookmarkNote);
						}}
					>
						{t('bookmark_notes.add_notes_button')}
					</Button>
				)}
			</Flex>
		</Box>
	);
};
